import React, { Component } from 'react';
import { MoneyInputField, SelectField } from 'common/components/form_fields';
import Money from 'common/components/money';
import { getDetailedAwardCost } from 'pap/utils';

/*
 * 1-1 budget step.
 *
 * @author: Nathan Ozelim <nathan@startupfoundry.com>
*/

const OPTIONS = [
  {field: 'request_quote', label: 'Ask For a Quote'},
  {field: 'send_offer', label: 'Set My Own Budget'}
]

export default class Budget1to1 extends Component {
  constructor(props) {
    super(props)

    this.handleChange = this.handleChange.bind(this)
  }

  handleChange(fieldName, value) {
    const currentValue = this.props.input.value || {}
    this.props.input.onChange({...currentValue, [fieldName]: value})
  }

  render () {
    const { input, meta: { error={} }, currentAwards } = this.props;
    const stepValues = input.value || {};
    let detailedCost = {};

    if (stepValues['budget_option'] == 'send_offer') {
      const referenceAward = currentAwards.find((a) => a.feature.position == 0);
      if (referenceAward) {
        detailedCost = getDetailedAwardCost(referenceAward.feature, stepValues['award_1_1'] || 0);
      }
    }

    return (
      <div className="pap-budget row columns medium-6">
        <SelectField meta={{}} allowEmpty={true} options={OPTIONS} label="Select Budget"
          input={{
            value: stepValues['budget_option'],
            name: 'budget_option',
            onChange: ({target: {value}}) => this.handleChange('budget_option', value)
          }}/>

        {stepValues['budget_option'] == 'send_offer' &&
        <MoneyInputField label="Creative Award"
          meta={{
            error: error['award_1_1'],
            touched: !!stepValues['award_1_1'],
            invalid: !!error['award_1_1']
          }}
          input={{
            value: stepValues['award_1_1'],
            name: 'award_1_1',
            onChange: value => this.handleChange('award_1_1', value)
          }}/>}

        {stepValues['budget_option'] == 'send_offer' && !!stepValues['award_1_1'] &&
        <div>
          <div>Creative Award: <Money value={stepValues['award_1_1']}/></div>
          <div>crowdspring Fee: <Money value={detailedCost.fees}/></div>
          <h3>Total: <Money value={detailedCost.total}/></h3>
        </div>}

      </div>)
  }
};



// WEBPACK FOOTER //
// ./pap/components/common/input_fields/budget_1_1.jsx